export default () => ({
  header: {
    paddingTop: '24px',
    paddingLeft: '24px',
    paddingRight: '24px'
  }
});
